// Resolves backend-provided WS URL to the host the browser can actually reach.
//
// DEV: keep path/query and swap host to current Vite host (localhost or LAN IP).
// PROD: force host to VITE_API_URL host (Worker), not Pages frontend host.
export function resolveWsUrl(wsUrl: string): string {
  try {
    const u = new URL(wsUrl);

    if (import.meta.env.DEV) {
      const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${proto}//${window.location.host}${u.pathname}${u.search}`;
    }

    const apiBase = import.meta.env.VITE_API_URL as string | undefined;
    if (apiBase) {
      const api = new URL(apiBase);
      const proto = api.protocol === 'https:' ? 'wss:' : 'ws:';
      return `${proto}//${api.host}${u.pathname}${u.search}`;
    }
  } catch {
    // Malformed URL - use original.
  }
  return wsUrl;
}

